import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';

@Component({
  selector: 'app-_125_ServicesDeliveredSummaryRptParams',
  templateUrl: './_125_ServicesDeliveredSummaryRptParams.component.html',
  styleUrls: ['./_125_ServicesDeliveredSummaryRptParams.component.css']
})
export class _125_ServicesDeliveredSummaryRptParamsComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; 
  selectedPAU: SelectItem; selectedSite: SelectItem; selectedStudent: SelectItem;  
  _PAUid: string = null; _siteId: string = null; _studentId: string = null; _selectedFilterCriteria: string = null; 
  public showSpinner: boolean = false;
  incorrectlyOrderedAttendancePeriods: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- NO PAUs --", shortText: null, updatedOn: null }];
  lookupStudentList: ILookupBase[] = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
  filterCriteriaList: ILookupBase[] = [ { value: null, label: "-- Select a Filter Criteria --", shortText: null, updatedOn: null },
                                        { value: 'IsCurrentlyEnrolled', label: "Is Currently Enrolled", shortText: null, updatedOn: null },
                                        { value: 'WasEnrolledThisSchoolYear', label: "Was Enrolled This School Year", shortText: null, updatedOn: null }] as ILookupBase[];

  schoolYearPeriodList: ILookupBase[];
  selectedSchoolYearPeriodStart: string;
  selectedSchoolYearPeriodEnd: string;
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
    this.date = new Date();
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());

    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }

        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Student lookup
              let params = {} as IStudentSearchParameters;
              params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
              params.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
                    this._studentId = null;
                  }
                  else {
                    this.lookupStudentList = [{ value: 'AllStudents', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
                    this._studentId = 'AllStudents';
                    this.selectedStudent = this.lookupStudentList[0];
                  }
                },
                  err => console.error(err)
                );

            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
    );


    this._lookupService.getILookupBaseList(this._baseUrl + 'api/Lookup/GetSchoolYearAttendancePeriodList/')
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.schoolYearPeriodList = [{ value: null, label: "-- NO School Year Att Periods! --", shortText: null, updatedOn: null }]
        }
        else {
          this.schoolYearPeriodList = res;
          this.selectedSchoolYearPeriodEnd = this.schoolYearPeriodList[0].value;
          this.selectedSchoolYearPeriodStart = this.schoolYearPeriodList.find(x => x.value === (this.selectedSchoolYearPeriodEnd.substr(0, 10) + "01")).value;
          this.incorrectlyOrderedAttendancePeriods = false;
        }
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];

          //Student lookup
          let params = {} as IStudentSearchParameters;
          params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
          params.siteIdArray = this.getSiteIdList().split('^');

          this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
            .subscribe((res: ILookupBase[]) => {
              if (!res || res.toString() === "") {
                this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
                this._studentId = null;
              }
              else {
                this.lookupStudentList = [{ value: 'AllStudents', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
                this._studentId = 'AllStudents';
                this.selectedStudent = this.lookupStudentList[0];
              }
            },
              err => console.error(err)
            );

        }
      },
        err => console.error(err)
      );
  }

  setFilterCriteria(selection: ILookupBase): void {
    this._selectedFilterCriteria = selection.value;
  }

  setSite(id): void {
    this._siteId = id.value;

    //Student lookup
    let params = {} as IStudentSearchParameters;
    params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
    params.siteIdArray = this.getSiteIdList().split('^');

    this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
          this._studentId = null;
        }
        else {
          this.lookupStudentList = [{ value: 'AllStudents', label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
          this._studentId = 'AllStudents';
          this.selectedStudent = this.lookupStudentList[0];
        }
      },
        err => console.error(err)
      );
  }

  setStudent(id): void {
    this._studentId = id.value;
  }

  setSchoolYearPeriodEnd(schoolYearAttPeriod): void {
    this.checkAttendancePeriods();
  }

  setSchoolYearPeriodStart(schoolYearAttPeriod): void {
    this.checkAttendancePeriods();
  }

  checkAttendancePeriods(): void {
    if (this.selectedSchoolYearPeriodStart > this.selectedSchoolYearPeriodEnd) {
      this.incorrectlyOrderedAttendancePeriods = true;
    }
    else {
      this.incorrectlyOrderedAttendancePeriods = false;
    }
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  getstudentId(): string {
    let studentId: string;

    if (this.selectedStudent.value == null) {
      studentId = 'AllStudents';
    }
    else {
      studentId = this.selectedStudent.value;
    }
    return studentId;
  }

  viewReport() {
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    var selectedStudentValue = this.lookupStudentList.find(z => z.value === this._studentId).label;
    var selectedFilterCriteriaValue = this.filterCriteriaList.find(a => a.value === this._selectedFilterCriteria).label;

    let reportParamArray: IReportParameter[] = [];
    reportParamArray.push(
      { parameterName: 'SiteIdList', parameterValue: this.getSiteIdList().replace('undefined', '') },
      { parameterName: 'LocalStudentIdList', parameterValue: this._studentId },
      { parameterName: 'FilterCriteria', parameterValue: this._selectedFilterCriteria },
      { parameterName: 'PAUSelection', parameterValue: selectedPAUValue.replace(/--/g, '').trim() },
      { parameterName: 'SiteSelection', parameterValue: selectedSiteValue.replace(/--/g, '').trim() },
      { parameterName: 'StudentSelection', parameterValue: selectedStudentValue.replace(/--/g, '').trim() },
      { parameterName: 'FilterCriteriaSelection', parameterValue: selectedFilterCriteriaValue },
      { parameterName: 'StaffIdList', parameterValue: this._myGlobals.spedSecurityUser.id.toString() },
      { parameterName: 'StartingSchoolYearAttendancePeriod', parameterValue: this.selectedSchoolYearPeriodStart },
      { parameterName: 'EndingSchoolYearAttendancePeriod', parameterValue: this.selectedSchoolYearPeriodEnd }
    ); 

    let now = new Date();
    let localReportFileName = '125_ServicesDeliveredSummary_' + now.toLocaleDateString() + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = 'SpedXReports';
    reportRequest.reportFileName = "IEP_SpecialEd_ServicesDeliveredSummary";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
